var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDownWhiteCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_658_1221)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_658_1221",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0.5H0V20.5H20V0.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_658_1221)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 20.1094C9.34973 20.1095 8.70092 20.0441 8.06359 19.9141C6.83443 19.6624 5.66687 19.1711 4.62753 18.4682C3.08257 17.4253 1.87321 15.9567 1.14597 14.2404C0.900281 13.6591 0.712752 13.0549 0.586126 12.4366C0.325824 11.1586 0.325824 9.84132 0.586126 8.56336C0.837865 7.3342 1.32918 6.16664 2.03202 5.12731C3.07494 3.58238 4.54349 2.37305 6.25976 1.64582C6.84107 1.40013 7.44528 1.2126 8.06355 1.08598C9.34152 0.82567 10.6589 0.82567 11.9368 1.08598C13.166 1.33772 14.3336 1.82903 15.3729 2.53188C16.9178 3.5748 18.1272 5.04338 18.8544 6.75969C19.1001 7.34096 19.2876 7.94513 19.4143 8.56336C19.6746 9.84132 19.6746 11.1586 19.4143 12.4366C19.1625 13.6658 18.6712 14.8333 17.9684 15.8727C16.9254 17.4176 15.4568 18.627 13.7405 19.3542C13.1592 19.5999 12.555 19.7874 11.9368 19.9141C11.2995 20.0441 10.6506 20.1095 10.0002 20.1094ZM5.14382 7.51758L4.11062 8.50813L9.94788 14.1047L15.7851 8.50813L14.7519 7.51758L9.94788 12.1235L5.14382 7.51758Z",
    fill: "#F9F9F9"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_658_1221"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownWhiteCircle);
export default __webpack_public_path__ + "static/media/ArrowDownWhiteCircle.22efa8fee4a9dac095192c9a4af85278.svg";
export { ForwardRef as ReactComponent };